import React, { useState } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import HowItWorks from "./pages/HowItWorks";
import HostPortal from "./pages/HostPortal";

function App() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="app">
      <nav className="nav" role="navigation" aria-label="Main navigation">
        <div className="container">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div>
                <Link to="/" className="nav-logo" onClick={() => setMenuOpen(false)}>Comp'd<span>Life</span></Link>
                <div className="nav-motto">"Play big. Live bigger."</div>
              </div>
            </div>
            <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
              {menuOpen ? "✕" : "☰"}
            </button>
            <div className={`nav-links ${menuOpen ? "open" : ""}`}>
              <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={() => setMenuOpen(false)}>Home</Link>
              <Link to="/events" className={location.pathname.startsWith("/events") ? "active" : ""} onClick={() => setMenuOpen(false)}>Events</Link>
              <Link to="/how-it-works" className={location.pathname === "/how-it-works" ? "active" : ""} onClick={() => setMenuOpen(false)}>How It Works</Link>
              <Link to="/events" className="btn btn-nav-cta" style={{ whiteSpace: "nowrap", color: "#FFFFFF" }} onClick={() => setMenuOpen(false)}>Get Comp'd</Link>
            </div>
          </div>
        </div>
      </nav>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:eventId" element={<EventDetail />} />
          <Route path="/hosts/:hostId" element={<HostPortal />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
        </Routes>
      </main>

      {/* Partners Section */}
      <section className="partners-section">
        <div className="container">
          <h3 className="partners-title">Our Casino Partners</h3>
          <div className="partners-grid">
            <div className="partners-group">
              <div className="partners-group-label">Las Vegas</div>
              <div className="partners-list">
                <span>Sphere Hotel</span><span>Westgate</span><span>Sahara</span>
                <span>Venetian / Palazzo</span><span>Palms</span><span>Station Palace</span>
                <span>Red Rock</span><span>Wynn / Encore</span>
              </div>
            </div>
            <div className="partners-group">
              <div className="partners-group-label">Domestic USA</div>
              <div className="partners-list">
                <span>Seneca Niagara, NY</span><span>Seneca Buffalo, NY</span>
                <span>Yaamava, CA</span><span>Harrah's New Orleans</span>
                <span>Harrah's / Harvey's Lake Tahoe</span>
              </div>
            </div>
            <div className="partners-group">
              <div className="partners-group-label">International</div>
              <div className="partners-list">
                <span>Baha Mar, Bahamas</span><span>Atlantis, Bahamas</span>
                <span>Hard Rock Punta Cana</span><span>Sortis, Panama</span>
                <span>Marriott, Aruba</span>
              </div>
            </div>
            <div className="partners-group">
              <div className="partners-group-label">Cruise Lines</div>
              <div className="partners-list">
                <span>🚢 Royal Caribbean</span><span>🚢 Celebrity</span>
                <span>🚢 Carnival</span><span>🚢 Holland America</span>
                <span>🚢 Princess</span><span>🚢 MSC</span>
                <span>🚢 NCL</span><span>🚢 Virgin Voyages</span>
                <span>🚢 Crystal Cruise</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <div className="footer-brand">Comp'd Life</div>
              <p className="footer-tagline">Play big. Live bigger. Get comp'd on the finest cruises, resorts, and events.</p>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Contact</div>
              <a href="tel:9542808181" className="footer-link">📞 (954) 280-8181</a>
              <a href="mailto:info@mrcompit.com" className="footer-link">✉️ info@mrcompit.com</a>
              <a href="mailto:booking@mrcompit.com" className="footer-link">📧 booking@mrcompit.com</a>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Quick Links</div>
              <Link to="/events" className="footer-link">Browse Events</Link>
              <Link to="/how-it-works" className="footer-link">How It Works</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Comp'd Life. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
